module.exports = __webpack_public_path__ + "img/aiIcon-asr-rt.60e6d4a2.svg";